import { useSelector } from 'react-redux';

import getCompany from 'API/Company/getCompany';
import { useQuery } from 'hooks/useCustomQuery';

/**
 * The currently selected company's record, straight from `/company/{id}`.
 *
 * Replaces reading `navigationLists.currentCompanyData`, which was a mutable
 * bag written by three unrelated callers. Keyed `['company', currentCompany]`
 * on purpose (2634) so this shares one cache entry — and therefore one network
 * request — with `useURLRewrite`, `Searchbar` and `CompanyStatus`.
 *
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
const useGetCurrentCompany = () => {
    const { currentCompany } = useSelector((state) => state.navigationLists);

    return useQuery({
        queryKey: ['company', currentCompany],
        queryFn: () => getCompany(currentCompany),
        enabled: Boolean(currentCompany),
        refetchOnWindowFocus: false,
    });
};

export default useGetCurrentCompany;
